import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivityModel } from '../user/activity/activity.model';
import { ActivityService } from '../user/activity/activity.service';
import { SubscriptionModel } from '../subscription/subscription.model';
import { CoreComponent } from '../../core/header/core.component';
import { HeaderTabService } from '../../shared/components/header-tabs/header-tab.service';

@Component({
    selector: 'convfact-invoicetabs',
    templateUrl: './invoice-tabs.component.html',
    styleUrls: ['./invoice-tabs.component.scss'],
    standalone: false
})
export class InvoiceTabsComponent implements OnInit {
  routes: { label: string; link: string; enable: boolean }[] = [];
  activity: ActivityModel[] = [];
  currentActivityUid!: string;
  currentActivityName!: string;
  subscriptionList: SubscriptionModel[] = [];
  isSelected = false;
  isResponsive!: boolean;

  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  public readonly activityService = inject(ActivityService);
  private readonly core = inject(CoreComponent);
  private readonly headerTabService = inject(HeaderTabService);

  constructor() {
    this.routes = [
      { label: 'Presupuestos', link: '/invoice/preinvoice', enable: true },
      { label: 'Albaranes', link: '/invoice/deliverynote', enable: true },
      { label: 'Certificaciones', link: '/invoice/certificate', enable: true },
      { label: 'Facturas', link: '/invoice/issued', enable: true },
      { label: 'Recurrentes', link: '/invoice/recurrents', enable: true },
      { label: 'Subvenciones', link: '/invoice/subvention', enable: true },
      { label: 'Factura simplificada', link: '/invoice/ticket', enable: true },
      { label: 'Anticipos de clientes', link: '/invoice/advancepaymentinvoice', enable: true },
      { label: 'Ingresos financieros', link: '/invoice/financialincome', enable: true },
      { label: 'Ordenes de trabajo', link: '/invoice/work-orders', enable: true },
      { label: 'Análisis Ingresos', link: '/invoice/analisis-ingresos', enable: true },
      // { label: 'Reservas', link: '/invoice/bookings', enable: true },
    ];
  }

  ngOnInit(): void {
    this.headerTabService.onEventSubject
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        const event = result.event;

        switch (event) {
          case 'on-select-tab':
            this.isSelected = true;
            break;
          case 'on-select-back':
            this.isSelected = false;
            break;
          case 'on-change-responsive':
            this.isResponsive = result.isResponsive;
            break;
        }
      });

    void this.loadInitialData();
  }

  private async loadInitialData(): Promise<void> {
    this.activity = await this.activityService.getList();

    const response = await this.activityService.loadData(this.core.activitySelected);
    this.currentActivityName = response.name;
  }

  onBack(): void {
    this.isSelected = false;
    this.headerTabService.onEvent({ event: 'on-select-back' });
  }
}